module.exports = __webpack_public_path__ + "img/qr.b833fc61.png";